import './WriteCard.scss';
import { Input } from 'antd';
import { RxCross2 } from 'react-icons/rx';
import React from 'react';
import { t } from '../../../i18n/i18n';

function WriteCard({ index, question, answer, handleDelete, id, setDataAI }) {
  const handleUpdateData = (e, id) => {
    const { name, value } = e.target;

    setDataAI((prevState) =>
      prevState.map((item) => (item.id === id ? { ...item, [name]: value } : item))
    );
  };

  return (
    <div className="card-container">
      <div className="card-index-badge">
        <span>{index}</span>
      </div>
      <span className="card-text">{t('WRITE_CART_SUBTITLE_QUESTION')}: </span>
      <Input.TextArea
        name="question"
        value={question}
        className="card-question"
        onChange={(e) => handleUpdateData(e, id)}
      />
      <span className="card-text">{t('ADD_CORRECT_ANSWER')}:</span>
      <Input
        name="answer"
        value={answer ?? ''}
        className="card-answer"
        onChange={(e) => handleUpdateData(e, id)}
      />
      <div className="card-remove">
        <RxCross2 onClick={() => handleDelete(id)} />
      </div>
    </div>
  );
}

export default WriteCard;
